import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _Checkbox2 from "element-ui/lib/theme-chalk/checkbox.css";
import "element-ui/lib/theme-chalk/base.css";
import _Checkbox from "element-ui/lib/checkbox";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PanelBorder from "../components/panel";
import MemberType from "../components/member-type";
import PanelPay from "../components/panel-pay";
import PanelPaysuccess from "../components/panel-paysuccess";
import PanelContact from "../components/panel-contact";
import PanelAgreement from "../components/panel-agreement";
import PanelYinSi from "../components/panel-yinsi";
import PanelUpgradeTip from "../components/update-tip";
import PanelExpired from "../components/panel-expired";
import _data from "../mock";
import { getAuthStorage } from "../../../api/service-localstorage";
import { mapState } from 'vuex';
import Clipboard from 'clipboard';
export default {
  components: {
    PanelBorder: PanelBorder,
    MemberType: MemberType,
    PanelPay: PanelPay,
    PanelPaysuccess: PanelPaysuccess,
    PanelContact: PanelContact,
    PanelAgreement: PanelAgreement,
    PanelYinSi: PanelYinSi,
    PanelUpgradeTip: PanelUpgradeTip,
    PanelExpired: PanelExpired,
    elCheckbox: _Checkbox
  },
  data: function data() {
    return {
      memberVisible: false,
      contactVisible: false,
      payVisible: false,
      // 展示支付弹窗
      paySuccessVisible: false,
      // 展示支付成功弹窗
      upgradeVisible: false,
      paySuccessValidTime: '',
      // 支付成功后的有效期
      expiredVisible: false,
      showOperate: false,
      price: 0,
      originPrice: 0,
      allMembers: _data,
      version: 'standard',
      // 当前的版本
      payVersion: 'standard',
      // 付费的版本
      checked: false,
      isRead: false,
      agreementVisible: false,
      yinSiVisible: false,
      updateType: '',
      versionLabel: '',
      updateTypeLabel: '',
      isTrialUser: true,
      isUpdate: false
    };
  },
  created: function created() {
    var _getAuthStorage = getAuthStorage(),
        version = _getAuthStorage.version,
        sysVersionInfo = _getAuthStorage.sysVersionInfo;

    this.version = version || 'customized';
    this.isTrialUser = sysVersionInfo === 0; // if (!this.timeliness) this.expiredVisible = true
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    timeliness: function timeliness(state) {
      return state.timeliness;
    }
  })), {}, {
    typeName: function typeName() {
      return this.typeToName(this.version);
    },
    deadDate: function deadDate() {
      var _getAuthStorage2 = getAuthStorage(),
          validTime = _getAuthStorage2.validTime;

      if (!validTime) return null;
      return validTime.split('-')[0] + '年' + validTime.split('-')[1] + '月' + validTime.split('-')[2] + '日';
    }
  }),
  watch: {
    timeliness: {
      handler: function handler(val) {
        if (!val) this.expiredVisible = true;
      },
      immediate: true
    }
  },
  methods: {
    // 退出登录
    loginOut: function loginOut() {
      this.$memberShow.hide();
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.reload(true);
    },
    // 支付成功
    onPaySuccess: function onPaySuccess(obj) {
      this.payVisible = false;
      this.paySuccessVisible = true;
      this.paySuccessValidTime = obj.validTime;
    },
    showPoup: function showPoup() {
      this.memberVisible = true;
    },
    closePoup: function closePoup() {
      this.memberVisible = false;
    },
    showPanelPay: function showPanelPay(params) {
      if (!this.checked) {
        this.isRead = true;
        return;
      }

      this.price = params.currentPrice;
      this.originPrice = params.originPrice;
      this.payVersion = params.version;

      if (this.isTrialUser || !this.timeliness) {
        // 试用用户和到期会员四个按钮都开放
        this.payVisible = true;
        return;
      }

      if (this.version === 'standard' && (params.version === 'speciality' || params.version === 'enjoy') || this.version === 'speciality' && params.version === 'enjoy') {
        this.upgradeVisible = true;
        this.versionLabel = this.typeToName(this.version);
        this.updateType = params.version;
        this.updateTypeLabel = this.typeToName(params.version);
        return;
      }

      this.payVisible = true;
    },
    continuePay: function continuePay() {
      this.upgradeVisible = false;
      this.isUpdate = true;
      this.payVisible = true;
      this.price = this.price;
      this.originPrice = this.originPrice;
      this.payVersion = this.updateType;
    },
    typeToName: function typeToName(type) {
      if (type === 'standard') {
        return '标准版会员';
      } else if (type === 'speciality') {
        return '专业版会员';
      } else if (type === 'enjoy') {
        return '尊享版会员';
      } else {
        return '定制平台';
      }
    },
    changeRead: function changeRead(val) {
      this.checked = val;
      this.isRead = !this.isRead;
    },
    closePanelPay: function closePanelPay() {
      this.payVisible = false;
      this.isUpdate = false;
    },
    showContact: function showContact() {
      this.contactVisible = true;
    },
    closePanelContact: function closePanelContact() {
      this.contactVisible = false;
    },
    closePanelUpgradeTip: function closePanelUpgradeTip() {
      this.upgradeVisible = false;
    },
    showAgreement: function showAgreement() {
      this.agreementVisible = true;
    },
    closeAgreement: function closeAgreement() {
      this.agreementVisible = false;
    },
    showYinsi: function showYinsi() {
      this.yinSiVisible = true;
    },
    closeYinSi: function closeYinSi() {
      this.yinSiVisible = false;
    },
    closePanelExpired: function closePanelExpired() {
      this.expiredVisible = false;
    },
    onTapCopyPhone: function onTapCopyPhone() {
      var clipboard = new Clipboard('#copy');
      clipboard.on('success', function (e) {
        _Message({
          message: '复制成功',
          type: 'success',
          customClass: 'message-own'
        }); // 释放内存


        clipboard.destroy();
      });
      clipboard.on('error', function (e) {
        // 不支持复制
        _Message({
          message: '该浏览器不支持自动复制，按 Ctrl+C 复制文字',
          type: 'warning',
          customClass: 'message-own'
        }); // 释放内存


        clipboard.destroy();
      });
    }
  }
};